import { render, staticRenderFns } from "./escapeBuyRecord.vue?vue&type=template&id=7d8bf92b&scoped=true"
import script from "./escapeBuyRecord.vue?vue&type=script&lang=js"
export * from "./escapeBuyRecord.vue?vue&type=script&lang=js"
import style0 from "./escapeBuyRecord.vue?vue&type=style&index=0&id=7d8bf92b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8bf92b",
  null
  
)

export default component.exports